import React, { FC, useCallback } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { useDispatch } from 'react-redux'
import { GreyButton } from 'components/Button'
import { push } from 'connected-react-router'
import { Description, MainHeadline } from 'components/Typography'
import { MonthlyReportList } from 'components/List'

const MonthlyReportTemplate: FC = () => {
  const dispatch = useDispatch()
  const backToRevenue = useCallback(() => dispatch(push('/account/revenue')), [])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'月次レポート一覧'} />
      <Spacer size={28} />
      <Description
        description={'毎月2日午前0時頃、先月の売上レポートが、\n' + '自動で発行され確認できるようになります。'}
      />
      <Spacer size={20} />
      <MonthlyReportList />
      <Spacer size={24} />
      <GreyButton label={'売上確認ページに戻る'} onClick={backToRevenue} size={'medium'} type={'outlined'} />
      <Spacer size={72} />
    </div>
  )
}

export default MonthlyReportTemplate
